module.exports = __webpack_public_path__ + "img/ring_r_s_0_1@2x.01db8b2f.png";